<template>
    <div class="row">
        <div class="col-md-12 p-2">
            <div class="alert mb-0 border">
                <div class="alert-body">
                    <div class="row">
                        <div class="col-12 mb-1">
                            <label class="form-label font-weight-bolder">Destek</label>
                            <div class="row mt-1">
                                <b-form-checkbox class="ml-50 col-auto" v-model="value.Destek">Destek</b-form-checkbox>
                            </div>
                            <div class="row mt-1" v-if="value.Destek">
                                <div class="col-6">
                                    <label class="form-label">Destek Tutarı</label>
                                    <v-currency-input input-class="text-right" :value="value.DestekAmount" v-on:update-value="v => value.DestekAmount = v"></v-currency-input>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 text-left">
                            <v-executer :loading="saving" text="Destek Bilgilerini Güncelle" :action="updateInfo"></v-executer>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import EmployeeOperationsApi from '@/api/employee-operations'
import { BFormCheckbox } from 'bootstrap-vue'
import VCurrencyInput from '@/components/VCurrencyInput.vue'

export default {
    components:{
        BFormCheckbox,
        VCurrencyInput
    },
    props:{
        id:[String,Number],
        value:Object,
        getPersonal:Function,
    },
    data(){
        return {
            saving: false
        }
    },
    methods:{
        updateInfo(){
            this.saving = true
            EmployeeOperationsApi.Employee.UpdateEkHakedisInfo({
                Destek:this.value.Destek,
                DestekAmount:this.value.DestekAmount,
                EmployeeId:this.id
            }).then(res=>{
                this.saving = false
                this.$result(res)
                if(res.data.Success){
                    this.getPersonal()
                }
            }).catch(err=>{
                this.$result(null,err)
                this.saving = false
            })
        }
    }
}
</script>
